import React, { useEffect, useRef } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_API_KEY";
const libraries = ["places"];
const containerStyle = { width: "100%", height: "100%", borderRadius: "10px" };

export default function MapView({ latitude, longitude }) {
  const mapRef = useRef(null);
  
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const center = {
    lat: parseFloat(latitude) || 0,
    lng: parseFloat(longitude) || 0,
  };

  useEffect(() => {
    if (mapRef.current && latitude && longitude) {
      mapRef.current.panTo(center);
    }
  }, [latitude, longitude]);

  const onMapLoad = (map) => {
    mapRef.current = map;
  };

  if (!isLoaded) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ height: "500px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading map...</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ height: "500px", borderRadius: "10px", overflow: "hidden", border: "1px solid #ddd" }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={14}
        onLoad={onMapLoad}
        options={{
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
        }}
      >
        <Marker position={center} />
      </GoogleMap>
    </div>
  );
}